var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.819V8.69139C1 6.65151 1.81034 4.69517 3.25276 3.25276C4.69517 1.81034 6.65151 1 8.69139 1C10.7313 1 12.6876 1.81034 14.13 3.25276C15.5724 4.69517 16.3828 6.65151 16.3828 8.69139V13.819",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3828 14.6734C16.3828 15.1267 16.2027 15.5614 15.8822 15.882C15.5616 16.2025 15.1269 16.3826 14.6736 16.3826H13.819C13.3657 16.3826 12.9309 16.2025 12.6104 15.882C12.2899 15.5614 12.1098 15.1267 12.1098 14.6734V12.1096C12.1098 11.6563 12.2899 11.2215 12.6104 10.901C12.9309 10.5805 13.3657 10.4004 13.819 10.4004H16.3828V14.6734ZM1 14.6734C1 15.1267 1.18008 15.5614 1.50061 15.882C1.82115 16.2025 2.25589 16.3826 2.7092 16.3826H3.5638C4.01711 16.3826 4.45185 16.2025 4.77238 15.882C5.09292 15.5614 5.273 15.1267 5.273 14.6734V12.1096C5.273 11.6563 5.09292 11.2215 4.77238 10.901C4.45185 10.5805 4.01711 10.4004 3.5638 10.4004H1V14.6734Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support_icon.d58ea3f5d94ec8142df29de446a0fc0e.svg";
export { ForwardRef as ReactComponent };